import React from 'react'
import ReactDOM from 'react-dom'

import './index.css'
import App from './App'
import { unregister } from './registerServiceWorker'
import ZendeskWidget from './components/shared/ZendeskWidget/ZendeskWidget'

ReactDOM.render(
  <>
    <App />
    <ZendeskWidget />
  </>,
  document.getElementById('root')
)

unregister()
